import { makeAutoObservable, observable } from 'mobx';

import { apiFetch } from 'framework/api';
import { ModelValidator } from 'framework/mobx-integration';
import { createLogEntry } from 'areas/services/api';
import { LogEntryFormConfig, LogEntryModel, LogEntryStatus } from '../../types';

export class LogEntryFormStore {
	model = observable<LogEntryModel>({
		status: LogEntryStatus.Ok,
		message: '',
	});
	validator = new ModelValidator(this.model);
	saving: boolean = false;

	constructor(public config: LogEntryFormConfig) {
		makeAutoObservable(this, {
			config: false,
		});

		this.validator.required('message');
	}

	get okDisabled() {
		return this.saving || !this.validator.valid;
	}

	save = async () => {
		this.validator.validate();
		if (!this.validator.valid) {
			return false;
		}

		this.saving = true;
		try {
			const result = await apiFetch(
				createLogEntry({
					serviceId: this.config.serviceId,
					state: this.model.status,
					message: this.model.message.trim(),
				}),
			);
			if (!result.success) {
				return false;
			}

			this.config.onSave?.();
			return true;
		} finally {
			this.saving = false;
		}
	};

	destroy() {
		this.validator.destroy();
	}
}
